import { render, staticRenderFns } from "./VolunteerProfileLeftSection.vue?vue&type=template&id=492701be&scoped=true"
import script from "./VolunteerProfileLeftSection.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileLeftSection.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileLeftSection.vue?vue&type=style&index=0&id=492701be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492701be",
  null
  
)

export default component.exports